import { Box, TableCell, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { PropsWithChildren } from "react";

const useStyles = makeStyles((theme: Theme) => ({
  rowTableIcon: {
    color: theme.palette.primary.main,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
    gap: "0.25rem",
    margin: "0.5rem 0",
  },
}));

const TableActions: React.FC<PropsWithChildren> = ({ children }) => {
  const classes = useStyles();

  return (
    <TableCell>
      <Box className={classes.rowTableIcon} data-action="true">
        {children}
      </Box>
    </TableCell>
  );
};

export default TableActions;
